// extracted by mini-css-extract-plugin
export default {"body":"Homepage_body__elRuG","mainContainer":"Homepage_mainContainer__5t6Gg"};